import React from 'react';
import { bool, func, number, oneOfType, string } from 'prop-types';
import { connect } from 'react-redux';
import { formValueSelector, SubmissionError } from 'redux-form';
import axios from 'axios';
import { Intent } from '@blueprintjs/core';

import FlashMessage from 'components/common/flash_message';
import headersForAjaxJson from 'utils/headersForAjaxJson';
import PartnerSubmissionForm from './PartnerSubmissionForm';
import {
  nextPage as nextPageAction,
  previousPage as previousPageAction,
  setPage as setPageAction
} from './redux/actions/uiActions';
import { accessTokenFromUrl } from './utils';

export function PartnerSubmissionFormContainer({
  activePage,
  experienced,
  nextPage,
  previousPage,
  setPage
}) {
  const handleSubmit = (values) => {
    const accessToken = accessTokenFromUrl();
    const requestUrl = `/affiliate-contact/${accessToken}`;
    const requestMethod = accessToken === '' ? axios.post : axios.put;

    return requestMethod(
      requestUrl,
      { partner: values },
      { headers: headersForAjaxJson() }
    ).then(
      () => setTimeout(() => setPage(4), 100), // Waiting for Redux Form to finish its submit success actions
      ({
        response: {
          data: {
            errors: { partner, category_details: categoryDetails }
          }
        }
      }) => {
        FlashMessage.show({
          message: 'Form is invalid. Please make corrections and resubmit.',
          intent: Intent.DANGER
        });
        throw new SubmissionError({ ...partner, categoryDetails });
      }
    );
  };

  return (
    <PartnerSubmissionForm
      activePage={activePage}
      experienced={experienced}
      handleSubmit={handleSubmit}
      nextPage={nextPage}
      previousPage={previousPage}
      setPage={setPage}
    />
  );
}

PartnerSubmissionFormContainer.propTypes = {
  activePage: number.isRequired,
  experienced: oneOfType([bool, string]),
  nextPage: func.isRequired,
  previousPage: func.isRequired,
  setPage: func.isRequired
};

PartnerSubmissionFormContainer.defaultProps = {
  experienced: false
};

const mapStateToProps = ({ ui: { activePage }, ...state }) => {
  const selector = formValueSelector('partnerSubmissionForm');
  const experienced = selector(state, 'experienced');
  return { activePage, experienced };
};

export default connect(mapStateToProps, {
  nextPage: nextPageAction,
  previousPage: previousPageAction,
  setPage: setPageAction
})(PartnerSubmissionFormContainer);
